<template>
  <div>
    <label v-if="label" class="pl-2 label-text">
      {{ label }}
      <v-icon
        v-if="required"
        class="uikit-icon mini-star size-mini-star error"
      />
    </label>
    <v-autocomplete
      v-model="dataValue"
      no-data-text="Список пуст"
      autocomplete="new-password"
      class="mt-1 rounded-lg mini-text base-select field-edit"
      outlined
      dense
      :no-filter="noFilter"
      hide-no-data
      :clearable="clearable"
      :items="items || []"
      :item-value="itemValue"
      :item-text="itemText"
      :placeholder="placeholder"
      :disabled="disabled"
      :return-object="returnObject"
      :class="errorMessages && errorMessages.length ? 'field-error' : ''"
      :hide-details="hideDetails"
      :error-messages="errorMessages"
      :search-input.sync="search"
      :multiple="multiple"
      :hint="hint"
      :persistent-hint="persistentHint"
      :loading="loading"
      @focus="direction='rotate-180'"
      @blur="direction=''"
    >
      <template>
        <div
          slot="append"
          class="d-flex align-center"
        >
          <v-icon
            class="uikit-icon chevron-down size-24 delay-03"
            :class="direction"
          />
        </div>
      </template>

      <template
        v-if="multiple"
        #selection="data"
      >
        <v-chip
          v-bind="data.attrs"
          :input-value="data.selected"
          close
          @click="data.select"
          @click:close="select(data.item)"
        >
          <span :style="(isXs || isHorizontalLabel) && 'overflow: scroll'">{{ getText(data.item) }}</span>
        </v-chip>
      </template>

      <template #item="data">
        <v-list-item
          :class="isSelected(data.item) ? 'base-select-active' : ''"
          :disabled="data.item.disabled"
          @click="select(data.item)"
        >
          <v-icon
            v-if="isSelected(data.item)"
            style="margin-right: 12px"
            class="uikit-icon check lightGrey size-20"
          />
          <v-list-item-content>{{ getText(data.item) }}</v-list-item-content>
        </v-list-item>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import { JSDataTypes } from '@/enums/types'
import { mapGetters } from 'vuex'

export default {
  name: 'UIAutocomplete',

  props: {
    label: {
      type: String,
      default: null,
    },
    value: {
      type: [Object, Number, String, Array, null],
      default: null,
    },
    items: {
      type: Array,
      default: null,
    },
    itemText: {
      type: [String, Function],
      default: 'name',
    },
    itemValue: {
      type: String,
      default: 'id',
    },
    returnObject: {
      type: Boolean,
      default: false,
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
    required: {
      type: Boolean,
      default: false,
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: 'Выбрать из списка',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    hint: {
      type: String,
      default: '',
    },
    persistentHint: {
      type: Boolean,
      default: true,
    },
    searchInput: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    noFilter: {
      type: Boolean,
      default: true,
    },
  },

  data: () => ({ direction: '' }),

  computed: {
    ...mapGetters('breakpoint', ['isXs', 'isHorizontalLabel']),

    search: {
      get() {
        return this.searchInput
      },
      set(val) {
        this.$emit('update:search-input', val)
        this.$emit('searchData', val)
      },
    },

    dataValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
        this.$emit('change', val)
      },
    },
  },

  methods: {
    getText(item) {
      if (!item) return ''
      return typeof this.itemText === JSDataTypes.Function ? this.itemText(item) : item[this.itemText]
    },

    isEqual(first, second) {
      return this.returnObject ? first[this.itemValue] === second[this.itemValue]
        : first[this.itemValue] === second
    },

    isMultipleEqual(first, second) {
      return second.length && second.some((el) => this.isEqual(first, el))
    },

    isSelected(item) {
      return this.dataValue && (this.multiple ? (this.isMultipleEqual(item, this.dataValue))
        : (this.isEqual(item, this.dataValue)))
    },

    select(item) {
      if (this.multiple) {
        const index = this.returnObject ? this.dataValue.findIndex((el) => item[this.itemValue] === el[this.itemValue])
          : this.dataValue.findIndex((el) => item[this.itemValue] === el)

        if (index === -1) this.dataValue.push(this.returnObject ? item : item[this.itemValue])
        else this.dataValue.splice(index, 1)

        this.$emit('input', this.dataValue)
        this.$emit('change', this.dataValue)
      } else {
        this.dataValue = this.returnObject ? cloneDeep(item) : item[this.itemValue]
      }
    },
  },
}
</script>

<style
  scoped
  lang="scss"
>
.base-select-active {
  background: var(--v-lightGrey3-base) !important;
}
</style>
